import moment from "moment"
import { defaultLogo } from "./images"
import React from "react"

const host =
  process.env.NODE_ENV === "production"
    ? "https://app.etr.ai"
    : "http://localhost:4000"

export const structureEventData = (event) => {
  let { metadata } = event

  let location = {
    name: "New York City",
    address: {
      streetAddress: "129 W 29th St",
      addressLocality: "New York",
      postalCode: "10001",
      addressRegion: "NY",
      addressCountry: "USA",
    },
  }

  let eventData = {
    "@context": "http://schema.org",
    "@type": "Event",
    name: event.name,
    startDate: moment(metadata["Event Date"]).format("YYYY-MM-DD"),
    description: event.description || metadata["Event Type Description"],
    location: {
      "@type": "Place",
      ...location,
    },
    performer:
      metadata.Speakers &&
      metadata.Speakers.map((speaker) => ({
        "@type": "Person",
        name: speaker["Speaker Name"],
        jobTitle: speaker["Speaker Title"],
      })),
  }

  return eventData
}

export const MetaData = (seo) => {
  if (!seo) {
    throw new Error("You must provide an SEO object.")
  }

  /* meta tag filters
   **
   ** To add a new meta tag, add the desired property name to an array
   ** and the tag will be included in the list tags for that type.
   **
   */

  let twitter = ["card", "description", "title", "image"]
  let og = ["type", "description", "url", "title", "image", "locale"]
  let article = ["published_time", "author", "publisher", "tag"]
  let fb = ["pages"]

  // The resulting list of meta tags components we will return.
  let tags = []

  // We hardcode these properties for now.
  seo.locale = "en_US"
  seo.card = "summary_large_image"
  seo.pages = "622251791269070"

  tags.push(<title key={tags.length}>{seo.title}</title>)
  tags.push(
    <meta key={tags.length} name="description" content={seo.description} />
  )

  // create twitter meta tags start
  for (let i = 0; i < twitter.length; i++) {
    let key = twitter[i]
    if (!seo[key] || seo[key] === "") continue
    tags.push(
      <meta key={tags.length} property={`twitter:${key}`} content={seo[key]} />
    )
  }
  // end twitter

  // create OpengGraph meta tags start
  for (let i = 0; i < og.length; i++) {
    let key = og[i]
    if (!seo[key] || seo[key] === "") continue
    tags.push(
      <meta key={tags.length} property={`og:${key}`} content={seo[key]} />
    )
  }
  // end OpengGraph

  // create article OpengGraph meta tags start
  for (let i = 0; i < article.length; i++) {
    let key = article[i]
    if (!seo[key] || seo[key] === "") continue

    // If there's an article:tag we need to create multiple article:tag metas.
    if (key === "tag") {
      seo.tag.forEach((tag) => {
        tags.push(
          <meta key={tags.length} property="article:tag" content={tag} />
        )
      })
      continue
    }

    tags.push(
      <meta key={tags.length} property={`article:${key}`} content={seo[key]} />
    )
  }
  // end article OpengGraph

  // create facebook meta tags start
  for (let i = 0; i < fb.length; i++) {
    let key = fb[i]
    if (!seo[key] || seo[key] === "") continue
    tags.push(
      <meta key={tags.length} property={`fb:${key}`} content={seo[key]} />
    )
  }
  // end facebook

  return tags
}

export const structureSearchData = (url) => {
  return JSON.stringify({
    "@context": "http://schema.org",
    "@type": "WebSite",
    url: url,
    potentialAction: {
      "@type": "SearchAction",
      target: "https://app.etr.ai/marketplace?keyword={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  })
}

export const structureTopicData = (data) => {
  let offers = data.totalPrice
    ? {
        "@type": "Offer",
        priceCurrency: "USD",
        price: data.totalPrice,
        availability: "http://schema.org/InStock",
      }
    : ""

  return JSON.stringify({
    "@context": "http://schema.org/",
    "@type": "Product",
    name: data.name,
    image: [data.image],
    description: data.description,
    brand: {
      "@type": "Organization",
      name: "ETR",
    },
    offers,
  })
}

export const structuredPageData = (url) => {
  return JSON.stringify({
    "@context": "http://schema.org",
    "@type": "Organization",
    url: url,
    logo: defaultLogo,
  })
}

export const stucturedPrivacyPolicyData = (url) => {
  return JSON.stringify({
    "@context": "http://schema.org",
    "@type": "Organization",
    url: url,
    logo: defaultLogo,
  })
}

export const structureProductData = (data) => {
  let offers = data.price
    ? {
        "@type": "Offer",
        price: data.price,
        priceCurrency: "USD",
        availability: "http://schema.org/InStock",
      }
    : ""

  return JSON.stringify({
    "@context": "http://schema.org/",
    "@type": "Product",
    name: data.name,
    image: [data.image],
    description: data.description,
    brand: {
      "@type": "Organization",
      name: "ETR",
    },
    offers,
  })
}

// json-ld for article.
export const structurePostData = (data) => {
  return JSON.stringify({
    "@context": "http://schema.org",
    "@type": "Article",
    headline: data.title,
    image: data.image,
    author: data.author,
    keywords: data.tag,
    publisher: {
      "@type": "Organization",
      name: data.publisher,
      logo: {
        "@type": "ImageObject",
        url:
          "https://s3.amazonaws.com/dev-etr/images/defaults/etr-logo-white.png",
      },
    },
    url: data.url,
    datePublished: data.published_time,
    description: data.description,
    articleBody: data.articleBody,
  })
}
